angular.module("showcaseApp")
    .controller("ModalFiltersContentController", ModalFiltersContentController);

/** @ngInject */
function ModalFiltersContentController(
    $translate,
    $localStorage,
    toastr,
    moment,
    paginationConstants,
    flyersConstants
) {

    var vm = this;
    const DATE_FORMAT = $translate.instant("momentDateFormat");

    vm.$onInit = init;
    function init() {
        if (vm.options) {
            vm.originalFilters = angular.copy(vm.filters);
            vm.listFilter = vm.list;
            vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];
            if (vm.options.dynamicFilterOptions) {
                vm.dynamicFilterOptions = {
                    categories: vm.options.dynamicFilterOptions.categories || getDynamicFilterOptionsModel(),
                    brands: vm.options.dynamicFilterOptions.brands || getDynamicFilterOptionsModel(),
                    colors: vm.options.dynamicFilterOptions.colors || getDynamicFilterOptionsModel(),
                    sizes: vm.options.dynamicFilterOptions.sizes || getDynamicFilterOptionsModel()
                };
            } else {
                vm.categories = vm.options.categories;
                vm.brands = vm.options.brands;
                vm.colors = vm.options.colors;
                vm.sizes = vm.options.sizes;
            }
            vm.configurations = vm.options.configurations;
            vm.bedrooms = vm.options.bedrooms;
            vm.bathrooms = vm.options.bathrooms;
            vm.parkingSpots = vm.options.parkingSpots;
            vm.tags = vm.options.tags;
            vm.hasInventory = vm.filters.hasInventory;
            vm.itemsPerPageOptions = vm.options.itemsPerPageOptions;
            vm.sortOptions = vm.options.sortOptions;
            vm.numPerPage = vm.options.numPerPage;
            vm.selectedSort = vm.options.selectedSort;
            vm.isHubContext = $localStorage.defaultStore.hubContext;
            vm.genders = flyersConstants.SELECT_OPTIONS.RETAIL.GENDERS;
            vm.imageOptions = flyersConstants.SELECT_OPTIONS.RETAIL.IMAGE_OPTIONS;
            
            vm.promotionalPriceOptions = [
                { label: 'flyers.filters.promotionalPrice.both', value: null },
                { label: 'flyers.filters.promotionalPrice.with', value: true },
                { label: 'flyers.filters.promotionalPrice.without', value: false }
            ];

            vm.showHubSyncFilter = vm.options.showHubSyncFilter || false;

            if (vm.showHubSyncFilter) {
                vm.hubSyncOptions = flyersConstants.SELECT_OPTIONS.RETAIL.HUB_SYNC_OPTIONS;
            }
            vm.isBagFilter = vm.options.isBagFilter || false;
            vm.groupByColor = vm.options.groupByColor;
            vm.groupByColorEnabled = vm.options.groupByColorEnabled;

            normalizeBagFilters();
            normalizeImageFilter();
            if (vm.showHubSyncFilter) {
                normalizeHubSyncFilter();
            }
            normalizePromotionalPriceFilter();

            assignFilterOptionMethods();

            loadStoreCategory();

            if (vm.isBagFilter) {
                formatFilterOptions();
            }
        }
    }

    function normalizeBagFilters() {
        if (!vm.options.isBagFilter || !vm.filters) return;

        normalizeColors();
        normalizeSizes();
        normalizeTags();
    }

    function normalizeImageFilter() {
        var imageOptions = vm.filters.imageOptions;

        if (angular.isArray(imageOptions)) {
            imageOptions = imageOptions.length > 0 ? imageOptions[0] : null;
        }

        if (imageOptions) {
            var value = imageOptions.value || imageOptions;
            vm.filters.imageOptions = vm.imageOptions.find(function(opt) {
                return opt.value === value;
            }) || null;
        } else {
            vm.filters.imageOptions = null;
        }

    }

    function normalizeHubSyncFilter() {
        var hubSyncFilter = vm.filters.hubSyncFilter;

        if (hubSyncFilter && typeof hubSyncFilter === 'string') {
            vm.filters.hubSyncFilter = vm.hubSyncOptions.find(function(opt) {
                return opt.value === hubSyncFilter;
            }) || null;
        } else if (!hubSyncFilter) {
            vm.filters.hubSyncFilter = null;
        }
    }

    function normalizePromotionalPriceFilter() {
        var promoPrice = vm.filters.hasPromotionalPrice;
        if (promoPrice !== null && promoPrice !== undefined && typeof promoPrice !== 'object') {
            vm.filters.hasPromotionalPrice = vm.promotionalPriceOptions.find(function(opt) {
                return opt.value === promoPrice;
            }) || null;
        } else if (promoPrice === null || promoPrice === undefined) {
            vm.filters.hasPromotionalPrice = null;
        }
    }

    function normalizeColors() {
        if (vm.filters.colors && vm.filters.colors.length > 0) {
            vm.filters.colors = vm.filters.colors.map(function (color) {
                if (typeof color === 'string') {
                    var matchingColor = vm.options.colors.find(function (c) {
                        return c.label === color;
                    });
                    return {
                        label: color,
                        id: matchingColor ? matchingColor.id : vm.options.colors.indexOf(color) + 1
                    };
                }
                return color;
            });
        }
    }

    function normalizeSizes() {
        if (vm.filters.sizes && vm.filters.sizes.length > 0) {
            vm.filters.sizes = vm.filters.sizes.map(function (size) {
                if (typeof size === 'string') {
                    var matchingSize = vm.options.sizes.find(function (s) {
                        return s.label === size;
                    });
                    return {
                        label: size,
                        id: matchingSize ? matchingSize.id : vm.options.sizes.indexOf(size) + 1
                    };
                }
                return size;
            });
        }
    }

    function normalizeTags() {
        if (vm.filters.tags && vm.filters.tags.length > 0) {
            vm.filters.tags = vm.filters.tags.map(function (tag) {
                if (typeof tag === 'string') {
                    var matchingTag = vm.options.tags.find(function (t) {
                        return t.label === tag;
                    });
                    return {
                        label: tag,
                        id: matchingTag ? matchingTag.id : vm.options.tags.indexOf(tag) + 1
                    };
                }
                return tag;
            });
        }
    }

    function assignFilterOptionMethods() {
        if (!vm.options) return;

        const mapping = {
            listCategoryFilterOptions: 'listCategoryFilterOptions',
            listBrandFilterOptions: 'listBrandFilterOptions',
            listColorFilterOptions: 'listColorFilterOptions',
            listSizeFilterOptions: 'listSizeFilterOptions'
        };

        Object.keys(mapping).forEach(function (key) {
            if (vm.options[key] && angular.isFunction(vm.options[key])) {
                vm[mapping[key]] = findBindingBaseFunction(vm.options[key]);
            }
        });
    }

    function loadStoreCategory() {
        vm.storeCategory = $localStorage.defaultStore.storeInfo.storeCategory;
    }

    vm.closeModal = function (response, applyFilters) {
        if (!applyFilters) {
            vm.filters = vm.originalFilters;
        }
        if (response) {
            angular.copy(response, vm.response);
        } else {
            var cleanResponse = {
                filtered: vm.filters,
                selectedFilters: angular.copy(vm.filters),
                listFilter: vm.listFilter,
                sortSelected: vm.selectedSort,
                listFilter: vm.listFilter,
                sortSelected: vm.selectedSort,
                numPerPage: vm.numPerPage,
                groupByColor: vm.groupByColor
            };

            angular.copy(cleanResponse, vm.response);
        }
    };

    vm.clearFilters = function () {
        vm.filters.region = [];
        vm.filters.categories = [];
        vm.filters.brands = [];
        vm.filters.colors = [];
        vm.filters.sizes = [];
        vm.filters.genders = [];
        vm.filters.imageOptions = null;
        vm.filters.bedrooms = [];
        vm.filters.bathrooms = [];
        vm.filters.parkingSpots = [];
        vm.filters.minValue = null;
        vm.filters.maxValue = null;
        vm.filters.minMeters = null;
        vm.filters.maxMeters = null;
        vm.filters.sinceDate = null;
        vm.filters.untilDate = null;
        vm.filters.configurations = [];
        vm.filters.tags = [];
        vm.filters.hubSyncFilter = null;
        vm.filters.hasPromotionalPrice = null;
        vm.hasInventory = false;
        vm.filters.sortSelected = {
            value: "lastModifiedDate",
            direction: "desc",
        };
    };

    vm.applyFilters = function () {
        var filters = angular.copy(vm.filters);
        filters.region = (filters.region || []).map(function (region) {
            return region.polygons;
        });
        var imageOptions = filters.imageOptions;
        if (!angular.isArray(imageOptions)) {
            imageOptions = imageOptions ? [imageOptions] : [];
        }
        if (angular.isArray(filters.categories)) {
            filters.categories = (filters.categories || []).map(function (category) {
                return category.key;
            });
        } else if (angular.isObject(filters.categories)) {
            if (filters.categories.except) {
                filters.categories.except = filters.categories.except.map(function (category) {
                    return category.key;
                });
            }
            if (filters.categories.only) {
                filters.categories.only = filters.categories.only.map(function (category) {
                    return category.key;
                });
            }
        }
        if (angular.isArray(filters.brands)) {
            filters.brands = (filters.brands || []).map(function (brand) {
                return brand.name;
            });
        } else if (angular.isObject(filters.brands)) {
            if (filters.brands.except) {
                filters.brands.except = filters.brands.except.map(function (brand) {
                    return brand.name;
                });
            }
        }
        filters.colors = (filters.colors || []).map(function (color) {
            return color.label;
        });
        filters.sizes = (filters.sizes || []).map(function (size) {
            return size.label;
        });
        filters.genders = (filters.genders || []).map(function (gender) {
            return gender.id;
        });
        filters.imageOptions = imageOptions.map(function (imageOption) {
            return imageOption.value;
        });
        if (vm.showHubSyncFilter) {
            var hubSyncFilter = filters.hubSyncFilter;
            if (hubSyncFilter && hubSyncFilter.value !== null && hubSyncFilter.value !== undefined) {
                filters.hubSyncFilter = hubSyncFilter.value;
            } else {
                filters.hubSyncFilter = null;
            }
        }
        filters.bedrooms = (filters.bedrooms || []).map(function (bedroom) {
            return bedroom.value;
        });
        filters.bathrooms = (filters.bathrooms || []).map(function (
            bathroom
        ) {
            return bathroom.value;
        });
        filters.parkingSpots = (filters.parkingSpots || []).map(function (
            parking
        ) {
            return parking.value;
        });
        filters.configurations = (filters.configurations || []).map(
            function (configuration) {
                return configuration.code;
            }
        );
        filters.sortDirection = filters.sortSelected
            ? filters.sortSelected.direction
            : "desc";
        filters.sortBy = filters.sortSelected
            ? filters.sortSelected.value
            : "lastModifiedDate";

        if (filters.region.length > 0) {
            vm.listFilter.region = filters.region;
        } else {
            vm.listFilter.region = [];
        }

        if (angular.isArray(filters.categories)) {
            if (filters.categories.length > 0) {
                vm.listFilter.categoryKeys = filters.categories;
                vm.listFilter.categoryKey = filters.categories[0];
            } else {
                delete vm.listFilter.categoryKey;
                delete vm.listFilter.categoryKeys;
            }
        } else if (angular.isObject(filters.categories)) {
            vm.listFilter.categorySelection = filters.categories;
        } else {
            delete vm.listFilter.categoryKey;
            delete vm.listFilter.categoryKeys;
            delete vm.listFilter.categorySelection;
        }

        if (angular.isArray(filters.brands)) {
            if (filters.brands.length > 0) {
                vm.listFilter.brand = filters.brands[0];
                vm.listFilter.brands = filters.brands;
            } else {
                delete vm.listFilter.brand;
                delete vm.listFilter.brands;
            }
        } else if (angular.isObject(filters.brands)) {
            vm.listFilter.brandSelection = filters.brands;
        } else {
            delete vm.listFilter.brand;
            delete vm.listFilter.brands;
            delete vm.listFilter.brandSelection;
        }

        if (angular.isArray(filters.colors)) {
            if (filters.colors.length > 0) {
                vm.listFilter.colors = filters.colors;
            } else {
                delete vm.listFilter.colors;
            }
        } else if (angular.isObject(filters.colors)) {
            vm.listFilter.colorSelection = filters.colors;
        } else {
            delete vm.listFilter.colors;
            delete vm.listFilter.colorSelection;
        }

        if (angular.isArray(filters.sizes)) {
            if (filters.sizes.length > 0) {
                vm.listFilter.sizes = filters.sizes;
            } else {
                delete vm.listFilter.sizes;
            }
        } else if (angular.isObject(filters.sizes)) {
            vm.listFilter.sizeSelection = filters.sizes;
        } else {
            delete vm.listFilter.sizes;
            delete vm.listFilter.sizeSelection;
        }

        if (filters.genders.length > 0) {
            vm.listFilter.genders = filters.genders;
        } else {
            vm.listFilter.genders = [];
        }

        if (filters.imageOptions.length > 0) {
            vm.listFilter.imageOptions = filters.imageOptions;
        } else {
            vm.listFilter.imageOptions = [];
        }

        if (filters.configurations.length > 0) {
            vm.listFilter.configurations = filters.configurations;
        } else {
            vm.listFilter.configurations = [];
        }

        if (filters.bedrooms.length > 0) {
            vm.listFilter.bedrooms = filters.bedrooms;
        } else {
            vm.listFilter.bedrooms = [];
        }

        if (filters.bathrooms.length > 0) {
            vm.listFilter.bathrooms = filters.bathrooms;
        } else {
            vm.listFilter.bathrooms = [];
        }

        if (filters.parkingSpots.length > 0) {
            vm.listFilter.parkingSpots = filters.parkingSpots;
        } else {
            vm.listFilter.parkingSpots = [];
        }

        if (filters.sortBy && filters.sortDirection) {
            vm.listFilter.sortBy = filters.sortBy;
            vm.listFilter.sortDirection = filters.sortDirection;
        } else {
            vm.listFilter.sortBy = "";
            vm.listFilter.sortDirection = "";
        }

        if (filters.minValue || filters.minValue !== "") {
            vm.listFilter.minValue = filters.minValue;
        } else {
            vm.listFilter.minValue = null;
        }

        if (filters.maxValue || filters.maxValue !== "") {
            vm.listFilter.maxValue = filters.maxValue;
        } else {
            vm.listFilter.maxValue = null;
        }

        if (filters.minMeters || filters.minMeters !== "") {
            vm.listFilter.minMeters = filters.minMeters;
        } else {
            vm.listFilter.minMeters = null;
        }

        if (filters.maxMeters || filters.maxMeters !== "") {
            vm.listFilter.maxMeters = filters.maxMeters;
        } else {
            vm.listFilter.maxMeters = null;
        }

        if (filters.sinceDate || filters.sinceDate !== "") {
            vm.listFilter.sinceDate = moment(
                filters.sinceDate,
                DATE_FORMAT
            ).toDate();
        } else {
            delete vm.listFilter.sinceDate;
            vm.listFilter.sinceDate = null;
        }

        if (filters.untilDate || filters.untilDate !== "") {
            vm.listFilter.untilDate = moment(
                filters.untilDate,
                DATE_FORMAT
            ).toDate();
        } else {
            delete vm.listFilter.untilDate;
            vm.listFilter.untilDate = null;
        }

        vm.listFilter.hasInventory = vm.hasInventory;
        vm.filters.hasInventory = vm.hasInventory;

        if (filters.hasPromotionalPrice && typeof filters.hasPromotionalPrice === 'object') {
            filters.hasPromotionalPrice = filters.hasPromotionalPrice.value;
        }
        vm.listFilter.hasPromotionalPrice = filters.hasPromotionalPrice;

        if (vm.showHubSyncFilter) {
            if (filters.hubSyncFilter) {
                vm.listFilter.hubSyncFilter = filters.hubSyncFilter;
            } else {
                delete vm.listFilter.hubSyncFilter;
            }
        }

        vm.closeModal(
            {
                filtered: filters,
                selectedFilters: angular.copy(vm.filters),
                listFilter: vm.listFilter,
                sortSelected: vm.selectedSort,
                sortSelected: vm.selectedSort,
                numPerPage: vm.numPerPage,
                groupByColor: vm.groupByColor
            },
            true
        );
    };

    vm.onChangeItemsPerPage = function (newValue) {
        vm.numPerPage = newValue;
    };

    vm.onSelectedSortOption = function (newValue) {
        vm.selectedSort = newValue;
    };

    vm.getTranslateKey = function (key) {
        return getTranslateKey(vm.isImmoContext, key);
    }

    function formatFilterOptions() {
        if (vm.filters.categories) {
            var categories = [];
            vm.filters.categories.map(function (category) {
                vm.categories.forEach(function (configured_category) {
                    if (configured_category.key === category) {
                        categories.push({
                            label: configured_category.title,
                            id: configured_category.id,
                            title: configured_category.title,
                            key: category,
                        });
                    }
                });
            });
            vm.filters.categories = categories;
        }

        if (vm.filters.sizes) {
            var sizes = [];
            vm.filters.sizes.map(function (size) {
                vm.sizes.forEach(function (sizeOption) {
                    if (angular.isString(size)) {
                        if (sizeOption.label === size) {
                            sizes.push({label: size, id: sizeOption.id});
                        }
                    } else {
                        if (sizeOption.label === size.label) {
                            sizes.push(sizeOption);
                        }
                    }
                });
            });
            vm.filters.sizes = sizes;
        }

        if (vm.filters.brands) {
            var brands = [];
            vm.filters.brands.map(function (brand) {
                vm.brands.forEach(function (configured_brand) {
                    if (configured_brand.name === brand) {
                        brands.push({
                            name: brand,
                            label: brand,
                            id: configured_brand.id,
                        });
                    }
                });
            });
            vm.filters.brands = brands;
        }

        if (vm.filters.colors) {
            var colors = [];
            vm.filters.colors.map(function (color) {
                vm.colors.forEach(function (colorOption) {
                    if (angular.isString(color)) {
                        if (colorOption.label === color) {
                            colors.push({label: color, id: colorOption.id});
                        }
                    } else {
                        if (colorOption.label === color.label) {
                            colors.push(colorOption);
                        }
                    }
                });
            });
            vm.filters.colors = colors;
        }

        if (vm.filters.genders) {
            var genders = [];
            vm.filters.genders.map(function (gender) {
                vm.genders.forEach(function (configured_gender) {
                    if (configured_gender.id === gender) {
                        genders.push({
                            label: configured_gender.label,
                            id: gender,
                        });
                    }
                });
            });
            vm.filters.genders = genders;
        }

        if (vm.filters.imageOptions && vm.filters.imageOptions.length > 0) {
            var selected = [];
            vm.filters.imageOptions.forEach(function (savedOption) {
                var match = vm.imageOptions.find(function (opt) {
                    return opt.value === savedOption || opt.id === savedOption || opt.value === savedOption.value || opt.id === savedOption.id;
                });
                if (match) selected.push(match);
            });
            vm.filters.imageOptions = selected;
        }

        if (vm.filters.tags) {
            var tags = [];
            vm.filters.tags.map(function (tag) {
                vm.tags.forEach(function (tagOption) {
                    if (angular.isString(tag)) {
                        if (tagOption.label === tag) {
                            tags.push({label: tag, id: tagOption.id});
                        }
                    } else {
                        if (tagOption.label === tag.label) {
                            tags.push(tagOption);
                        }
                    }
                });
            });
            vm.filters.tags = tags;
        }

        if (vm.filters.bedrooms) {
            var bedrooms = [];
            vm.filters.bedrooms.map(function (bedroom) {
                vm.bedrooms.forEach(function (bedroomOption) {
                    if (angular.isNumber(bedroom)) {
                        if (bedroomOption.value === bedroom) {
                            bedrooms.push(bedroomOption);
                        }
                    } else {
                        if (bedroomOption.value === bedroom.value) {
                            bedrooms.push(bedroomOption);
                        }
                    }
                });
            });
            vm.filters.bedrooms = bedrooms;
        }

        if (vm.filters.bathrooms) {
            var bathrooms = [];
            vm.filters.bathrooms.map(function (bathroom) {
                vm.bathrooms.forEach(function (bathroomOption) {
                    if (angular.isNumber(bathroom)) {
                        if (bathroomOption.value === bathroom) {
                            bathrooms.push(bathroomOption);
                        }
                    } else {
                        if (bathroomOption.value === bathroom.value) {
                            bathrooms.push(bathroomOption);
                        }
                    }
                });
            });
            vm.filters.bathrooms = bathrooms;
        }

        if (vm.filters.parkingSpots) {
            var parkingSpots = [];
            vm.filters.parkingSpots.map(function (parkingSpot) {
                vm.parkingSpots.forEach(function (parkingSpotOption) {
                    if (angular.isNumber(parkingSpot)) {
                        if (parkingSpotOption.value === parkingSpot) {
                            parkingSpots.push(parkingSpotOption);
                        }
                    } else {
                        if (parkingSpotOption.value === parkingSpot.value) {
                            parkingSpots.push(parkingSpotOption);
                        }
                    }
                });
            });
            vm.filters.parkingSpots = parkingSpots;
        }

        if (vm.filters.sinceDate) {
            vm.filters.sinceDate = moment(vm.filters.sinceDate, DATE_FORMAT).format(DATE_FORMAT);
        }

        if (vm.filters.untilDate) {
            vm.filters.untilDate = moment(vm.filters.untilDate, DATE_FORMAT).format(DATE_FORMAT);
        }
    }


}
